// extracted by mini-css-extract-plugin
module.exports = {"inner":"modalInvite_inner__1jkNr","title":"modalInvite_title__3KNwB","form":"modalInvite_form__205Ld","note":"modalInvite_note__pU6hq","btnSubmit":"modalInvite_btnSubmit__3skyg"};